import React, { FC } from 'react';
import parse from 'html-react-parser';
import { ISkill } from '../../model/Skill.model';
import { ISkillDetail } from '../../model/SkillDetail.model';
import { ISkillLevel } from '../../model/SkillLevel.model';
import { IEmployeeProgression } from '../../model/EmployeeProgression.model';
import EmployeeProgressionOptions from './EmployeeProgressionOptions';
import SkillLevelCheckboxes from './SkillLevelCheckboxes';
import { Icon } from '../icons/icons';

interface DesktopCompetencyGridProps {
    progression: IEmployeeProgression | undefined;
    employeeProgressionLevels: any[];
    skill: ISkill;
    skillLevels: ISkillLevel[];
    borderColor?: string;
    bookmarkAdded(bookmark: IEmployeeProgression): void;
    bookmarkRemoved(bookmark: IEmployeeProgression): void;
}

const DesktopCompetencyGrid: FC<DesktopCompetencyGridProps> = ({
    progression, employeeProgressionLevels, skill, skillLevels, borderColor, bookmarkAdded, bookmarkRemoved
}) => {
    const getSkillDetails = (skill: ISkill, level: ISkillLevel) => {
        const details: JSX.Element[] = [];
        if (Array.isArray(skill.details)) {
            skill.details
                .filter((x: ISkillDetail) => x.skillLevelId === level.skillLevelId)
                .forEach((detail: ISkillDetail, i: number) => {
                    details.push(
                        <div key={i} className='m-t--75 m-b--75'>
                            {parse((detail.skillText + '').replaceAll('<a href=', '<a target="_blank" rel="noopener noreferrer" href='))}
                        </div>
                    );
                });
        }
        return details;
    };

    return (
        <div className='core-desktop-max-width bottom'>
            <div className='bordered-cell' style={{ borderColor }}>
                <div className='dis-flex dis-flex-rows dis-flex-aln-center dis-flex-jst-center gap--25'>
                    <EmployeeProgressionOptions
                        source="competencies"
                        progression={progression}
                        skill={skill}
                        skillLevels={skillLevels}
                        isManager={false}
                        bookmarkRemoved={bookmarkRemoved}
                        bookmarkAdded={bookmarkAdded}
                    />
                    <div className="gap--25 p--50 bdr-radius--25 bg-white no-border squared-layout mc-not-button">
                        <Icon name="icon-bulb-circle" className="icon icon-primary"></Icon>
                        <span className="clr-primary fnt-wght-500 aln-center">Competency Skill</span>
                    </div>
                </div>
            </div>
            {skillLevels.map((level, index) => (
                <div key={level.skillLevelId + index} className='bordered-cell' style={{ borderColor }}>
                    <div className='m-t--75'>{getSkillDetails(skill, level)}</div>
                    <SkillLevelCheckboxes
                        level={level}
                        skill={skill}
                        skillLevels={skillLevels}
                        isManager={false}
                        currentUpn={undefined}
                        employeeProgressionLevels={employeeProgressionLevels}
                        employeeProgressionLevelsLength={employeeProgressionLevels.length}
                        allReadonly={true}
                    />
                </div>
            ))}
        </div>
    );
};

export default DesktopCompetencyGrid;
